import { render, staticRenderFns } from "./CompanyEdit1.vue?vue&type=template&id=6054ed91&"
import script from "./CompanyEdit1.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports